<template>
<div>
  <!-- <pre>{{template}} {{page}} {{recipients}} {{title}}</pre>
  <v-btn @click='page--' >-</v-btn>
  <v-btn @click='page++' >+</v-btn> -->
  <!-- {{page}} -->
<v-window v-model="page" vertical touchless >
  <v-window-item :value='0' >
    <communication-template-list
      @selected='setSelectedCommunicationTemplate'
      @new='setCrud'
      :title='$t("comms.title")'
      :context='templateContext' >
    </communication-template-list>
  </v-window-item>

  <!-- select recipiients -->
  <v-window-item :value='1' >
    <v-card :flat='flat' >
      <v-card-title v-if='title' class='subheading' >
        {{title}}
      </v-card-title>
      <v-layout row wrap>
        <v-flex xs12 sm6 v-if='sender && sendToMe' >
          <recipient-card
            v-model='sender'
            @sendTo='setSendToMe'
            title='Send to me' >
          </recipient-card>
        </v-flex>
        <v-flex xs12 sm6 v-for='(recipient, index) in recipients' :key='recipient.id' >
          <recipient-card
            v-model='recipients[index]'
            @sendTo='setSendTo'
            :template-slug='template'
            :sender='sender'
            :context='context' >
          </recipient-card>
        </v-flex>
      </v-layout>
      <v-card-actions v-if='withSend' >
        <v-btn
          v-if='withCancel' flat text
          @click='$emit("close")' >Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click='send'
          :loading='sendRequest.loading'
          color='primary' >Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-window-item >
  <v-window-item :value='2' v-if='withSend' >
    <v-card :flat='flat' >
      <message-delivery-status :batch-id='batchId' >
      </message-delivery-status>
      <v-card-actions v-if='withSend' >
        <v-btn flat @click='page=0' >Back</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click='$emit("close")' color='primary' >Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-window-item>
  <v-window-item :value='3' >
    <communication-template-form
      v-model='selectedTemplate'
      @close='page=0'
      context-type='Appointment' >
    </communication-template-form>
  </v-window-item>
</v-window>
</div>

</template>
<script>
import CommunicationTemplateForm from '@/components/forms/CommunicationTemplateForm'
import CommunicationTemplateList from '@/components/lists/CommunicationTemplateList'
import ClientMixin from '@/mixins/client'
import RecipientCard from './RecipientCard'
import MessageDeliveryStatus from './MessageDeliveryStatus'
import Vue from 'vue'

const SELECT_TEMPLATE_PAGE = 0
const SELECT_RECIPIENTS_PAGE = 1
const RESULTS_PAGE = 2
const EDIT_COMMUNICATION_PAGE = 3

export default {
  name: 'SendTemplate',
  mixins: [ClientMixin],
  components: {RecipientCard, MessageDeliveryStatus, CommunicationTemplateForm, CommunicationTemplateList},
  props: {
    title: { type: String, default: 'Select recipients' },
    initialPage: { type: Number, default: 0 },
    clients: { type: Array, required: true },
    templateContext: { type: String, required: true },
    template: { type: String, required: false },
    flat: { type: Boolean, default: true },
    withSend: { type: Boolean, default: true },
    withCancel: { type: Boolean, default: true },
    sendToMe: { type: Boolean, default: true },
    touch: { type: Number, default: 0 },
    context: { type: Object, default: () => { return {} } }
  },
  data () {
    return {
      page: 0,
      sendTo: {},
      batchId: null,
      sendReqId: 'send-templated-communication',
      selectedTemplate: null,
      sendToMeTransports: {
        byEmail: false,
        bySMS: false
      }
    }
  },
  mounted () {
    this.batchId = Math.random().toString()
    this.page = this.initialPage
    this.$emit('sender', this.sender)
    if (this.template) {
      this.page = SELECT_RECIPIENTS_PAGE
    }
  },
  watch: {
    touch () {
      this.page = 0 // <- use a bigger hammer
      setTimeout(this.reset, 100)
      // this.reset()
    },
    sender () {
      this.$emit('sender', this.sender)
    },
    template () {
      if (this.template) {
        this.page = SELECT_RECIPIENTS_PAGE
      }
    },
    selectedRecipients () {
      this.$emit('recipients', this.selectedRecipients)
    },
    sendRequestStatus () {
      if (this.sendRequestStatus === 201) {
        this.page = RESULTS_PAGE
        let data = this.getObjectPath(this.sendRequest, 'result.data', {})
        if (data && data.length > 0) {
          this.batchId = data[0].batch_id
        }
      }
    }
  },
  computed: {
    sendRequest () {
      return this.$store.getters.getRequestById(this.sendReqId, true)
    },
    sendRequestStatus () {
      return this.sendRequest.status
    },
    sender () {
      let me = this.$store.getters.me
      let sender = this.asRecipient(me)
      sender.user_id = me.id
      sender.id = me.id
      sender.relationship_id = null
      return sender
    },
    selectedRecipients () {
      /* this is a lot harder than it needs to be */
      let recipients = []
      Object.entries(this.sendTo).forEach((entry) => {
        let key = entry[0]
        let yesno = entry[1]
        if (yesno === true) {
          let bits = key.split(':')
          let method = bits[0]
          let relationshipId = bits[1]
          let recipient = this.recipients.find((r) => { return r.relationship_id.toString() === relationshipId.toString() })
          let copy = JSON.parse(JSON.stringify(recipient))
          if (method === 'byEmail') {
            copy.preferred_transport = 'email'
            recipients.push(copy)
          }
          if (method === 'bySMS') {
            copy.preferred_transport = 'sms'
            recipients.push(copy)
          }
        }
      })
      if (this.sendToMeTransports.byEmail) {
        let copy = JSON.parse(JSON.stringify(this.sender))
        copy.preferred_transport = 'email'
        recipients.push(copy)
      }
      if (this.sendToMeTransports.bySMS) {
        let copy = JSON.parse(JSON.stringify(this.sender))
        copy.preferred_transport = 'sms'
        recipients.push(copy)
      }
      return recipients
    },
    recipients () {
      return this.clients.map((cli) => {
        return this.asRecipient(cli)
      })
    },
    payload () {
      return {
        batch_id: this.batchId,
        template: this.template,
        context: this.context,
        sender: this.sender,
        recipients: this.selectedRecipients
      }
    }
  },
  methods: {
    send () {
      let result = this.performAction(
        this.$appointmentguru,
        'practitioner',
        'appointments',
        this.context.id,
        'send_message',
        this.payload
      )
      let vm = this
      result.then(() => {
        vm.page = RESULTS_PAGE
      })
      // this.page = 1
      // this.$communicationguru
      //   .resource('send')
      //   .id(this.sendReqId)
      //   .create(JSON.stringify(this.payload))
    },
    setCrud (template) {
      this.selectedTemplate = template
      this.page = EDIT_COMMUNICATION_PAGE
    },
    setSelectedCommunicationTemplate (template) {
      this.template = template.slug
      this.page = SELECT_RECIPIENTS_PAGE
    },
    reset () {
      if (this.template) {
        this.page = SELECT_RECIPIENTS_PAGE
      } else {
        this.page = SELECT_TEMPLATE_PAGE
      }
      this.batchId = Math.random().toString()
    },
    setSendTo (method, yesno, recipient) {
      let key = method + ':' + recipient.relationship_id
      Vue.set(this.sendTo, key, yesno)
    },
    setSendToMe (method, yesno, recipient) {
      Vue.set(this.sendToMeTransports, method, yesno)
    }
  },
  i18n: {
    messages: {
      en: {
        comms: {
          title: 'Which type of notification would you like to send?'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SendTemplate.vue?c2ea628a